/** 상점 바로머니 엔티티 */
export default class SalesStoreBaromoney {
    /** 아이디 */
    id = 0;
    /** 허브명 */
    hubName = '';
    /** 상점 이름 */
    storeName = '';
    /** 가맹점종류 */
    storeType = '';
    /** 일시 */
    date = '';
    /** 캐쉬마감잔액 */
    cacheClosingBalance = 0;
    /** 캐쉬정산합계 */
    cacheSettlementTotal = 0;
    /** 캐쉬충전금액 */
    cacheCharge = 0;
    /** 캐쉬출금액 */
    withdrawalAmount = 0;
    /** 배달가맹비 */
    deliveryCommission = 0;
    /** 배달대행료 */
    deliveryAmount = 0;
    /** 주문가맹비 */
    orderChannelCommission = 0;
    /** 주문대행수수료 */
    orderChannelAmountCommission = 0;
    /** SMS차감액 */
    smsCacheDeduction = 0;
    /** 기타 */
    other = 0;
    constructor(_data = {}) {
        Object.assign(this, _data);
    }
}
